function CountryList() {

    return (
        <section className="container-fluid ps-5 p-md-5 bg-section text-white d-flex justify-content-start align-items-start align-items-md-center" style={{backgroundColor: 'rgba(13,83,116,255)'}}>

            <div>
                <p style={{ letterSpacing: '8%' }} className="fw-bold text-uppercase mt-3">Countries joining</p>
                <h1 className="fw-normal responsive-heading-small p-sm-0">RBSM<span className="fw-semibold"> <br />Delegate</span> From</h1>
            </div>

        </section>
    )
}

export default CountryList